import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

/**
 * @var string v1
 * @type {string}
 */
const v1 = '/rest/v1.0';

export const ROSTER_URL = `${BASE_URL}${v1}/studio/{studioOwnerName}/roster`;
export const ROSTER_PERFORMER_URL =
  `${BASE_URL}${v1}/studio/{studioOwnerName}/roster/{performerName}`;
export const PERFORMER_REVENUE_INSIGHTS =
  `${BASE_URL}/rest/v1.0/reporting/user/{performerName}/insights?from={startDate}&to={endDate}`;
export const PERFORMER_HOURS_URL =
  `${BASE_URL}${v1}/broadcasts/{performerName}?startTime={startTime}&endTime={endTime}`;

export default {
  ROSTER_URL,
  ROSTER_PERFORMER_URL,
  PERFORMER_HOURS_URL,
  PERFORMER_REVENUE_INSIGHTS,
};
